import { authHeader } from '@discover-frontend/auth';

/** API auth headers from HELIXA localStorage (kept in sync with SsoProvider refresh). */
export default async function apiAuthHeader() {
  return authHeader();
}
